import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, DatePicker, Divider, Icon, Input, message, Row, Select, Tag } from 'antd';
import TableCommon from '../../components/common/table/TableCommon';
import { currencyVND, dateToString } from '../../utils';
import * as CommonService from '../../services/CommonService';
import { INVOICE_ENDPOINT, PURCHASE_ORDER } from '../../services/endpoint';
import './style.scss';
import { useHistory } from 'react-router-dom';
import { PURCHASE_ORDER_STATUS } from '../../utils/const';
import { QuickPaymentForm } from '../../components/common/quick-payment';

const { Option } = Select;

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 20
};

export default () => {

	const [ds, setDs] = useState([]);
	const [selectedRow, setSelectedRow] = useState([]);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [showQuickPayment, setShowQuickPayment] = useState(false);

	const [searchValues, setSearchValues] = useState({});
	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});

	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			try {
				window.setLoading(true);
				const apiList = [await CommonService.get(PURCHASE_ORDER, {
					page: page.currentPage - 1,
					size: page.perpage
				})];
				const resp = Promise.all(apiList);
				const [purchaseOrderList] = await resp;
				setDs(purchaseOrderList.data?.contents);
				setPage({ ...page, total: purchaseOrderList.data?.totalElements });
			} catch (error) {
				message.error(error?.data?.message);
			} finally {
				window.setLoading(false);
			}
		};
		init();
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		try {
			const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
			window.setLoading(true);
			const resp = await CommonService.get(PURCHASE_ORDER, param);
			setDs(resp.data?.contents);
			setPage({
				total: resp.data?.totalElements,
				...pageParam
			});
		} catch (error) {
			message.error(error?.data?.message);
		} finally {
			window.setLoading(false);
		}
	};

	const renderStatus = (status) => {
		const currStatus = PURCHASE_ORDER_STATUS.find(el => el.value == status);
		return currStatus && <Tag style={{ width: '100px' }} color={currStatus.color}>{currStatus.name}</Tag>;
	};

	const columns = [
		{
			title: 'Mã đơn nhập',
			dataIndex: 'code',
			align: 'center',
			width: 150,
			render: (text, record) => {
				return <Button style={{ padding: '0' }} type={'link'} onClick={() => gotoDetail(record.id)}>{text}</Button>;
			}
		},
		{
			title: 'Ngày nhập',
			dataIndex: 'createdDate',
			width: 200,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		},
		{
			title: 'Trạng thái',
			dataIndex: 'status',
			width: 100,
			align: 'center',
			render: (status) => renderStatus(status)
		},
		{
			title: 'Chi nhánh nhập',
			dataIndex: 'branchName',
			align: 'center'
		},
		{
			title: 'Nhà cung cấp',
			dataIndex: 'supplierName',
			width: 'fit-content',
			align: 'center'
		},
		{
			title: 'Giá trị đơn hàng',
			dataIndex: 'price',
			width: 'fit-content',
			align: 'center',
			render: (text) => (<span>{currencyVND(text)}</span>)
		}
	];

	const handleChange = (value, key) => {
		searchValues[key] = value.toString();
		setSearchValues({ ...searchValues });
	};

	const goToCreate = () => {
		history.push('/purchase-order/create');
	};

	const gotoDetail = (id) => {
		history.push('/purchase-order/' + id);
	};

	const onEnter = (evt) => {
		if (evt.key === 'Enter') {
			onSearch(DEFAULT_PAGE);
		}
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: (selectedRowKeys, selectedRows) => {
			setSelectedRow(selectedRows);
			setSelectedRowKeys(selectedRowKeys);
		}
	};

	const handleQuickPayment = () => {
		CommonService.post(`${PURCHASE_ORDER}/payments`, selectedRow.filter(el => el.status === 1).map(el => el.id)).then(res => {
			if (res.status === 200) {
				message.success('Thanh toán thành công');
				onSearch(DEFAULT_PAGE);
				setSelectedRow([])
				setSelectedRowKeys([])
				setShowQuickPayment(false);
			}
		}).catch(error => {
			message.error(error?.data?.message || 'Có lỗi xảy ra');
		});
	};

	const handleShowModalQuickPayment = () => {
		if (selectedRow.filter(el => el.status === 1).length > 0) {
			setShowQuickPayment(true);
		} else {
			message.error('Vui lòng chọn đơn hàng đủ điều kiện và chưa thanh toán hết!');
		}
	};


	const renderHeader = () => {
		return <div>
			<span>{`Đã chọn ${selectedRow.length} đơn nhập hàng`}</span>
			{selectedRow.length > 0 &&
				<>
					<Button type={'link'} style={{ height: '80%' }} onClick={handleShowModalQuickPayment}>Thanh toán
						nhanh</Button>
				</>
			}
		</div>;
	};

	return (<Fragment>
			<Row className="mb-10" id={'product__action'}>
				<Col style={{visibility: 'hidden'}}>
					<div>
						<Divider type="vertical" />
						<Icon type="download" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Xuất file')}>Xuất file</span>
						<Divider type="vertical" />
						<Icon type="upload" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Nhập file')}>Nhập file</span>
					</div>
				</Col>
				<Col>
					<Button type="primary" style={{ width: '180px' }} id={'btn-create-product'} icon="plus"
									onClick={goToCreate}>Tạo đơn nhập hàng</Button>
				</Col>
			</Row>
			<Row>
				<div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
					<Input
						style={{ height: '32px' }}
						placeholder="Tìm kiếm theo mã đơn nhập, SĐT, tên, mã NCC"
						allowClear
						onChange={(value) => handleChange(value.target.value, 'value')}
						onKeyDown={onEnter}
					/>
					<Select
						mode="multiple"
						placeholder="Trạng thái"
						onChange={(value) => handleChange(value, 'status')}
						style={{ width: '35%' }}
						allowClear
						maxTagCount={1}
						maxTagTextLength={10}
					>
						{PURCHASE_ORDER_STATUS.map(el => (<Option key={el.value}>{el.name}</Option>))}
					</Select>
					<DatePicker.RangePicker
						allowClear
						placeholder={['Từ ngày', 'Đến ngày']}
						style={{ width: '600px' }}
						onChange={(value) => {
							const arr = value.map(el => dateToString(el, 'YYYY-MM-DD'));
							handleChange(arr[0], 'from');
							handleChange(arr[1], 'to');
						}} />
					<Button type="primary"
									style={{ width: '150px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</div>
			</Row>
			<TableCommon bordered={true}
									 title={renderHeader}
									 page={page}
									 setPage={setPage}
									 datasource={ds}
									 columns={columns}
									 onSearch={onSearch}
									 rowSelection={rowSelection}
			/>
			<QuickPaymentForm handlePayment={handleQuickPayment}
												selectedRow={selectedRow}
												show={showQuickPayment}
												onCancel={() => setShowQuickPayment(false)}
												warningMsg={<i>Lưu ý: Hệ thống sẽ thanh toán lần lượt các đơn nhập và tạo phiếu chi tương ứng
													với số lượng đơn
													nhập thanh toán.</i>}
			/>
		</Fragment>

	);
};
